module.exports = "<h1 id=reference>Widget Reference</h1> <p> All widgets are created within an existing element on your page. You can instantiate a widget using data- attributes on the element itself. You can instantiate a widget programmatically. In either case, all widgets can be customized using options and styled using CSS. </p>";


//////////////////
// WEBPACK FOOTER
// ./src/components/widgets/static/ref.html
// module id = 619
// module chunks = 1